export const EMOTIONS = ['happy','sad','angry','surprised','fearful','disgusted','neutral'];

export const ALL_EMOTIONS = [
  'happy','calm','concentrating','thinking','smirking',
  'sad','stressed','tense','dejected','surprised','fearful',
  'disgusted','angry','yawning','zoned_out','squinting','neutral',
];

export const EMOJI_MAP = {
  happy:'😊', calm:'😌', concentrating:'🧐', thinking:'🤔', smirking:'😏',
  sad:'😢', stressed:'😤', tense:'😬', dejected:'😔', surprised:'😲',
  fearful:'😨', disgusted:'🤢', angry:'😠', yawning:'🥱',
  zoned_out:'😶', squinting:'🤨', neutral:'😐',
};

export const EMOTION_COLORS = {
  happy:'#c8f060', calm:'#60f0c8', concentrating:'#60d4f0', thinking:'#f0d060', smirking:'#f0d080',
  sad:'#60a4f0', stressed:'#f08040', tense:'#f06840', dejected:'#8090c0', surprised:'#f0c060',
  fearful:'#c060f0', disgusted:'#60f0a4', angry:'#f06060', yawning:'#9060c0',
  zoned_out:'#606070', squinting:'#d0c060', neutral:'#a0a0b0',
};

export const MOOD_SCORES = {
  happy:100, smirking:80, calm:75, concentrating:70, thinking:65,
  surprised:60, squinting:55, neutral:55, zoned_out:45, yawning:40,
  tense:30, dejected:28, fearful:25, sad:25, stressed:20, disgusted:15, angry:10,
};

export const ENERGY_LEVELS = ['sleepy','tired','alert','energetic'];
export const ENERGY_EMOJI  = { sleepy:'😴', tired:'😑', alert:'😐', energetic:'⚡' };
export const ENERGY_COLORS = { sleepy:'#9060c0', tired:'#c09060', alert:'#60d4f0', energetic:'#60f0c8' };
export const ENERGY_SCORE  = { sleepy:10, tired:35, alert:65, energetic:95 };

export const SETTINGS_KEY = 'moodscope_settings';
